//获取Cookie值
export const getCookie = (c_name)=>{
  var c_start, c_end;
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(c_name + "=")
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1
      c_end = document.cookie.indexOf(";", c_start)
      if (c_end == -1) c_end = document.cookie.length
      return unescape(document.cookie.substring(c_start, c_end))
    }
  }
}

export const getURLParamH5 = function(key, url = window.location.href) {
  var reg = new RegExp("[?&]"+key+"=([^&]+)", "g");  
  var matcher = reg.exec(url);  
  var items = null;  
  if(null != matcher){  
    try{  
      items = decodeURIComponent(decodeURIComponent(matcher[1]));  
    }catch(e){  
      try{  
        items = decodeURIComponent(matcher[1]);  
      }catch(e){  
        items = matcher[1];  
      }  
    }  
   }  
   return items;  
}